
import useSVG from "../../../hooks/useSVG";
import { useMediaQuery } from "@mui/material";
import { ScreenType } from "../../../utils/breakpoints";

function DiagnosisToDischarge({goToScheduler}) {

    const { UseVirtualPT } = useSVG();
    const screenSize = ScreenType(useMediaQuery);

    const list = [
        {
            svg: "clock",
            title: "Flexible Scheduling",
            description: "Find appointments at your convenience."
        },

        {
            svg: "lock",
            title: "Secure & Confidential",
            description: "Privacy in every session from your own environment."
        },

        {
            svg: "plus",
            title: "One-on-One Care",
            description: "Focused attention based on your recovery needs."
        },

        {
            svg: "list",
            title: "Personal Treatment",
            description: "Receive a tailored recovery plan for your health goals."
        },

        {
            svg: "play",
            title: "Live Video Sessions",
            description: "Interact with your Physical Therapist in realtime."
        },

        {
            svg: "progress",
            title: "Progress Tracking",
            description: "Stay informed with your personal milestones."
        },


    ]

    return (
        <div id="v-pt-slider-3" className="v-pt-slides">
            <div id="v-pt-s3-body">
                <h2>From Diagnosis to Discharge - Experience:</h2>
                <div id="v-pt-s3-list">
                    {
                        list?.map((item) => {
                            return (
                                <div className="v-pt-s3-item">
                                    <div className="v-pt-s3-i-icon">
                                        {UseVirtualPT(item?.svg)}
                                    </div>
                                    <div className="v-pt-s3-i-desc">
                                        <p>
                                            <h5>{item?.title}</h5>{screenSize != "xl" && ": "}{item?.description}
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default DiagnosisToDischarge;